import { render } from "./DescriptionAndObjectivesDangerZone.vue?vue&type=template&id=52b80e54&scoped=true"
import script from "./DescriptionAndObjectivesDangerZone.vue?vue&type=script&lang=js"
export * from "./DescriptionAndObjectivesDangerZone.vue?vue&type=script&lang=js"

import "./DescriptionAndObjectivesDangerZone.vue?vue&type=style&index=0&id=52b80e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b80e54"]])

export default __exports__